import ValidatorResult from "../classes/validator.results";
export default class RegExpValidationRule {
    name = 'regexp';
    validate(validation, rule, value, object, manager) {
        //Message
        let tMessage = 'This is no a valid value';
        let tExpression = rule.props;
        let tRegExp = new RegExp(tExpression);
        //Rule
        if (value === undefined || value === null) {
            return new ValidatorResult(true);
        }
        if (tRegExp.test(value) === false) {
            return new ValidatorResult(false, tMessage);
        }
        return new ValidatorResult(true);
    }
}
